export default __webpack_public_path__ + "static/media/character-seal-idle.fa163837.png";